import { render, staticRenderFns } from "./PortTable.vue?vue&type=template&id=ed9a45e2&"
import script from "./PortTable.vue?vue&type=script&lang=js&"
export * from "./PortTable.vue?vue&type=script&lang=js&"
import style0 from "./PortTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports